let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3hu3X")).then(() => parcelRequire('azjDO'));